import { useCallback, useEffect } from "react";
import { useQuery } from "react-query";
import request from "../../util/request";
import _ from "lodash";

const QUERY_KEYS = {
  TAGS: "construction-tags",
  BUILDERS: "construction-builders",
};

const usePageQueries = ({
  isAuthenticated,
  buildersTableVariables,
  currentTag,
  currentDwtRange,
  currentLengthRange,
  currentcountryA3,
  currentVesselType,
  boundingBox,
}) => {
  console.log("query", currentcountryA3);

  const { data: tags } = useQuery(
    QUERY_KEYS.TAGS,
    async () => {
      const response = await request({
        url: `new-ships-api/public/tags`,
        method: "GET",
      });

      return response;
    },
    { refetchOnMount: false, refetchOnWindowFocus: false }
  );

  //////LOGIC TO FETCH SHIPYARD POSITIONS
  const isDefaultDwt =
    Array.isArray(currentDwtRange) &&
    currentDwtRange[0] === 1000 &&
    currentDwtRange[1] === 250000;
  const shipyardPositionsParams = {
    minLength: currentLengthRange?.[0],
    maxLength: currentLengthRange?.[1],
    countryA3: currentcountryA3,
    vesselType: currentVesselType,
    top: boundingBox._ne.lat,
    left: boundingBox._sw.lng,
    bottom: boundingBox._sw.lat,
    right: boundingBox._ne.lng,
    ...(isDefaultDwt
      ? {}
      : {
          minDwt: currentDwtRange?.[0],
          maxDwt: currentDwtRange?.[1],
        }),
  };

  const fetchShipyardPositions = async (params) => {
    const response = await request({
      url: `new-ships-api/public/shipyards/positions`,
      method: "GET",
      params: _.omitBy(params, _.isNil),
    });
    return response;
  };

  const { data: shipyardPositions } = useQuery(
    ["shipyardPositions", shipyardPositionsParams],
    () => fetchShipyardPositions(shipyardPositionsParams),
    {
      refetchOnWindowFocus: false,
    }
  );

  const fetchBuilders = useCallback(async () => {
    const params = {
      currentPage: (buildersTableVariables.pagination.current || 1) - 1,
      pageSize: buildersTableVariables.pagination.pageSize,
      orderBy: buildersTableVariables.sort.field,
      order: buildersTableVariables.sort.order || "ascend",
      minLength: currentLengthRange?.[0],
      maxLength: currentLengthRange?.[1],
      countryA3: currentcountryA3,
      vesselType: currentVesselType,
      ...(isDefaultDwt
        ? {}
        : {
            minDwt: currentDwtRange?.[0],
            maxDwt: currentDwtRange?.[1],
          }),
    };

    const response = await request({
      url: `new-ships-api/${isAuthenticated ? "user" : "public"}/shipyards`,
      method: "GET",
      params: _.omitBy(params, _.isNil),
    });
    return response;
  }, [
    buildersTableVariables,
    isAuthenticated,
    currentTag,
    currentcountryA3
  ]);

  const { data: builders, isFetching: isBuildersFetching } = useQuery(
    [
      QUERY_KEYS.BUILDERS,
      buildersTableVariables, 
      currentcountryA3
      // currentDwtRange,
      // currentLengthRange,
      // currentVesselType,
    ],
    fetchBuilders
  );

  return {
    tags,
    builders,
    isBuildersFetching,
    shipyardPositionsData: shipyardPositions,
  };
};

export default usePageQueries;
